import type { TaxonomyPathDisplayNames } from "app/pages/sales-intelligence/types/taxonomy";

const TAXONOMY_PATH_SEPARATOR = "/";

/**
 * Joins a taxonomy display names path for display.
 */
export const formatTaxonomyPathDisplayNames = (path: TaxonomyPathDisplayNames | undefined): string => {
    if (!path) {
        return "";
    }

    return path
        .map((segment) => segment?.trim())
        .filter(Boolean)
        .join(TAXONOMY_PATH_SEPARATOR);
};
